module.exports = __webpack_public_path__ + "img/cloud-vmware-2.8cffe65.jpg";